import { AxiosError } from 'axios';
import { GET_DATA_ARCHIVAL_TEMPLATE_URL } from '../../constants/apiUrls';
import { GET_DATA_ARCHIVAL_TEMPLATE } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request / Response
// =============================================================================

export interface DataArchivalTemplate {
  uuid: string;
  dataGroup: {
    name: string;
    description: string;
  }[];
  withDataLevel: boolean;
  dataLevel: DataLevel[];
}

export interface DataLevel {
  uuid: string;
  displayName: string;
}

interface Input {
  onSuccess?: (res: DataArchivalTemplate[]) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

// =============================================================================
// Query
// =============================================================================

export const useGetDataArchivalTemplate = ({ onError, onSuccess }: Input) => {
  const getDataArchivalTemplate = async () => {
    const res = await axiosClient.get<DataArchivalTemplate[]>(GET_DATA_ARCHIVAL_TEMPLATE_URL);

    return res.data;
  };

  return useCustomQuery([GET_DATA_ARCHIVAL_TEMPLATE], getDataArchivalTemplate, {
    onSuccess,
    onError,
  });
};
